(function () {
  "use strict";

  function hasAcceptedAnyCookies() {
    // OptanonConsent is the persisted OneTrust cookie; groups=C0001:1,C0002:0,... (C0001 is always-on strictly necessary)
    var match = document.cookie.match(/(?:^|; )OptanonConsent=([^;]*)/);
    if (!match) return false;

    var cookie;
    try {
      cookie = decodeURIComponent(match[1]);
    } catch (error) {
      cookie = match[1];
    }

    // interactionCount=0 means the banner defaults haven't been confirmed by a real user action yet;
    // some OneTrust setups pre-populate groups as granted by default, so that snapshot can't be trusted
    var interactionMatch = cookie.match(/interactionCount=(\d+)/);
    var interactionCount = interactionMatch ? parseInt(interactionMatch[1], 10) : 0;
    if (!interactionCount) return false;

    var groupsMatch = cookie.match(/groups=([^&]*)/);
    if (!groupsMatch) return false;

    var pairs = groupsMatch[1].split(',');
    var otherGroups = pairs.filter(function (pair) {
      return pair.indexOf('C0001:') !== 0;
    });

    return otherGroups.some(function (pair) {
      return pair.split(':')[1] === '1';
    });
  }

  function isOneTrustAvailable() {
    // If the CMP script is missing/blocked (ad blockers, network issues, etc.) there is nothing to gate
    // against; keeping the video stuck forever behind a banner that will never appear is worse than showing it
    return (
      (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.ToggleInfoDisplay === 'function') ||
      !!document.getElementById('onetrust-consent-sdk')
    );
  }

  function injectIframe(container) {
    if (!container || container.getAttribute('data-loaded') === 'true') return;

    var src = container.getAttribute('data-embed-src');
    if (!src) return;

    container.setAttribute('data-loaded', 'true');

    var iframe = document.createElement('iframe');
    iframe.src = src;
    var iframeLabel =
      container.getAttribute('data-title') ||
      (window.theme && window.theme.iframeLabels && window.theme.iframeLabels.youtube) ||
      'YouTube video';
    iframe.title = iframeLabel;
    iframe.setAttribute('aria-label', iframeLabel);
    iframe.frameBorder = '0';
    iframe.allow = container.getAttribute('data-allow') || '';
    iframe.allowFullscreen = true;
    iframe.className = container.getAttribute('data-iframe-class') || 'w-full h-full';

    var slideContainer = container.closest('.swiper-slide');
    var loader = slideContainer ? slideContainer.querySelector('.loader') : container.querySelector('.loader');
    if (loader) {
      loader.style.display = 'block';
      iframe.addEventListener('load', function () {
        loader.style.display = 'none';
      });
    }

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = 'none';

    container.appendChild(iframe);
  }

  function resetContainer(container) {
    var iframe = container.querySelector('iframe');
    if (iframe) iframe.remove();
    container.setAttribute('data-loaded', 'false');

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) playButton.style.display = '';

    var loader = container.querySelector('.loader');
    if (loader) loader.style.display = 'none';
  }

  function loadAfterConsentSettles(container) {
    window.setTimeout(function () {
      if (hasAcceptedAnyCookies()) {
        injectIframe(container);
        return;
      }

      // CMP never showed up after a reasonable wait (blocked/failed to load): fail open so the video isn't
      // permanently stuck behind a banner the visitor can never interact with
      if (!isOneTrustAvailable()) injectIframe(container);
    }, 1200);
  }

  function initContainer(container) {
    if (container.getAttribute('data-initialized') === 'true') return;
    container.setAttribute('data-initialized', 'true');

    loadAfterConsentSettles(container);

    var playButton = container.querySelector('[data-youtube-play]');
    if (playButton) {
      playButton.addEventListener('click', function () {
        if (hasAcceptedAnyCookies()) {
          injectIframe(container);
          return;
        }

        if (isOneTrustAvailable()) {
          window.OneTrust.ToggleInfoDisplay();
          return;
        }

        // No CMP to open preferences with: let the visitor watch the video rather than silently no-op
        injectIframe(container);
      });
    }

    // Stay on the placeholder until the user accepts at least one cookie category, then auto-load
    window.addEventListener('OneTrustGroupsUpdated', function onConsentUpdate() {
      if (hasAcceptedAnyCookies()) {
        injectIframe(container);
        return;
      }

      resetContainer(container);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-youtube-click-to-load]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support embeds added after initial load (e.g. swiper slides rendered dynamically)
  document.addEventListener('youtube-click-to-load:refresh', initAll);
})();
